import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './payment.types';

const resourceSelectors = generateResourceSelectors<types.IPayment>((state) => state.resource.payment);

export const paymentSelectors: types.IPaymentSelectors = {
  ...resourceSelectors,
};
